import Vue from 'vue'
import VueRouter from 'vue-router'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";


import vuetify from './plugins/vuetify' // path to vuetify export
import config from 'config'

//import VeeValidate from 'vee-validate';

//Vue.config.performance = true

import store from './store/store'
//import { router } from './router/router'

Vue.use(VueRouter);
//Vue.use(VeeValidate);

//import { ValidationProvider, extend } from 'vee-validate';
//import { required } from 'vee-validate/dist/rules';

//extend('required', {
//    ...required,
//    message: 'This field is required'
//});

// setup fake backend
//import { configureFakeBackend } from './_helpers';
//configureFakeBackend();

console.log(config);

Sentry.init({
   Vue,
   dsn: "https://6fe79fb70b6c4e208cd6992e045f935c@o1088024.ingest.sentry.io/6102494",
   integrations: [new Integrations.BrowserTracing()],
   environment: config.isProduction === true?"production":"development",
   logErrors: true,
   //trackComponents: true,
   //timeout: 4000,

   // Set tracesSampleRate to 1.0 to capture 100%
   // of transactions for performance monitoring.
   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
});

import App from './App.vue'

// This is a global mixin, it is applied to every vue instance. 
// Mixins must be instantiated *before* your call to new Vue(...)
Vue.mixin({
    data: function () {
        return {
            get apiURL() {
                return config.apiUrl;
            }
        }
    }
})

new Vue({
    store,
//    router,
    vuetify,
    components:
    {
    //    ValidationProvider
    },
    data: () => ({
        value: ''
    }),
    render: h => h(App)
}).$mount('#app')

